import { Icons } from '../../Icon/Icon';
import { ITimelineItem } from '../../inputs/Timeline/Timeline.model';

export type RecorderRoute = 'scheduler' | 'list' | 'gallery' | 'logs';
export type RecorderFilter = 'recording' | 'paused' | 'standby' | 'conflict' | null;
export type RecorderLogFilter = 'scheduled' | 'paused' | 'conflict' | null;

export interface RecorderActionConfig {
  title: string;
  icon: keyof typeof Icons;
  className: string;
}

export interface RecordableChannel {
  id: string;
  title: string;
  channelType: string;
  monitorPreviewURL?: string;
  monitorPreviewType?: 'stream' | 'image';
  enabled?: boolean;
}

export interface ChannelDetails {
  activeItem: ITimelineItem | null;
  latestItem: ITimelineItem | null;
  signal: string;
  status: string;
}

export const recorderActions: Record<string, RecorderActionConfig> = {
  record: { title: 'Record Now', icon: 'circle', className: 'action-record' },
  schedule: { title: 'Schedule', icon: 'timer', className: 'action-new' },
  pause: { title: 'Pause', icon: 'control_pause', className: 'action-pause' },
  stop: { title: 'Stop', icon: 'stopService', className: 'action-stop' },
  clear: { title: 'Clear', icon: 'erase', className: 'action-clear' },
  refresh: { title: 'Refresh', icon: 'refresh', className: 'action-log' },
};

export const routeActions: Record<RecorderRoute, RecorderActionConfig> = {
  scheduler: { title: 'Scheduler', icon: 'timer', className: 'action-route' },
  list: { title: 'List', icon: 'text', className: 'action-route' },
  gallery: { title: 'Gallery', icon: 'image', className: 'action-route' },
  logs: { title: 'Logs', icon: 'text', className: 'action-log' },
};
